<template>
    <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
            <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-semibold text-red-600">Warning</h3>
                <button @click="closePopup" class="text-gray-400 hover:text-gray-600">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
            <p class="text-gray-700 mb-4">{{ message }}</p>
            <div class="flex justify-end">
                <button @click="closePopup" class="bg-action text-white px-4 py-2 rounded font-semibold hover:bg-opacity-90">
                    OK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppErrorPopup',
    
    props: {
        show: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        }
    },
    
    methods: {
        closePopup() {
            this.$emit('close');
        }
    }
}
</script>